var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { ErrorMessage } from '../constants/messages';
/**
 * # createContext<S, C>
 *
 * - Context를 생성하고 사용하는 로직을 경량화(중복코드를 줄이기위한)한 함수
 *
 * ## 코드 예제
 *
 * ```tsx
 * interface StateInterface {}
 * const [context, useContext] = createContext<StateInterface>()
 * ```
 */
export function createContext() {
    var context = React.createContext(null);
    var Provider = function (_a) {
        var children = _a.children, otherProps = __rest(_a, ["children"]);
        return <context.Provider value={otherProps}>{children}</context.Provider>;
    };
    var useContext = function () {
        var _context = React.useContext(context);
        if (!_context) {
            // TODO: 에러 코드 보강 필요
            throw new Error(ErrorMessage.NOT_FOUND_CONTEXT);
        }
        return _context;
    };
    return [Provider, useContext];
}
//# sourceMappingURL=createContext.jsx.map